import { TABLE_ROW_DOWN_ICON } from './../../../../modules/shared/constants/table-row-down.icon';
import { EDITOR_COLORS } from './../../../../modules/shared/constants/user-preference.constant';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { saveAs } from "file-saver";
import { MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { Status } from 'src/app/modules/shared/models/status';
import { uploadFiles, validateFiles } from 'src/app/modules/shared/upload-files';
import { fieldTagsValidator } from 'src/app/modules/shared/validators/field-tags.validator';
import { NotificaitonEmailTemplateConfigModel, NotificationTemplateAttachments } from '../../models/notification-email-template.model';
import { EmailTemplateService } from '../../services/email-template.service';
import { EmailTemplateActionTypes } from '../models/email-template-action-types.enum';
import { EmailTemplateNotificationTypes, EmailTemplateNotificationTypesEnum } from '../models/email-template-notification-types.enum';
import { AppMainService } from './../../../../app-main.service';
import { AppMainComponent } from './../../../../app.main.component';
import { PurchasesService } from './../../../../inventory/purchases/purchases.service';
import { LeadAccountUpdateFieldsModel } from './../../../../misc/workflow/models/lead-account-update-fields.models';
import { WF_VENDOR_UPDATE_FIELDS } from './../../../../misc/workflow/models/workflow-vendor-fields.constants';
import { customFieldTagRegex } from './../../../../modules/shared/constants/custom-field-tag.regex';
import { FormControlList, FormControlListIds, getFormControlNameById } from './../../../../modules/shared/constants/formcontrol-list.constants';
import { AccountModuleId, BillOrderModuleId, BillPaymentModuleId, EstimateOrderModuleId, InvoiceOrderModuleId, LocationModuleId, ProductModuleId, PurchaseOrderModuleId, SOModuleId, TaskModuleId, VendorCreditModuleId, VendorModuleId, VendorReturnModuleId } from './../../../../modules/shared/constants/modules.constant';
import { FormErrorHandler } from './../../../../modules/shared/helpers/form-error-handler.helper';
import { ParseHelper } from './../../../../modules/shared/parse.helper';
import { DocumentViewerService } from './../../../../modules/shared/services/document-viewer.service';
import { SharedTemplateService } from './../../../../modules/shared/services/template.service';
import { MyDocumentsService } from './../../../../profile/my-documents/my-documents.service';
import { addInlineStyles } from "./../../../../modules/shared/helpers/add-inline-styles.helper";

import Quill from 'quill';
import QuillBetterTablePlus from 'quill-better-table-plus';
import { environment } from 'src/environments/environment';
Quill.register({
    'modules/better-table-plus': QuillBetterTablePlus
}, true);

@Component({
    selector: 'app-email-template',
    templateUrl: './email-template.component.html',
    styleUrls: ['./email-template.component.scss']
})
export class EmailTemplateComponent implements OnInit, OnChanges, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @ViewChild('editor') editor: any;
    @ViewChild('templateBodyArea') templateBodyAreaEl: any;

    @Input() display: boolean = false;
    @Input() isView: boolean = false;
    @Input() selectedEmailTemplate: NotificaitonEmailTemplateConfigModel;
    @Input() channelNames: any[];
    @Input() moduleId: number;

    @Output() dialogClose = new EventEmitter<boolean>();
    @Output() refreshList = new EventEmitter<boolean>();
    mimeTypes = [
        { extension: "csv", value: "text/csv" },
        { extension: "doc", value: "application/msword" },
        { extension: "docx", value: "application/msword" },
        { extension: "gif", value: "image/gif" },
        { extension: "jpeg", value: "image/jpeg" },
        { extension: "jpg", value: "image/jpeg" },
        { extension: "png", value: "image/png" },
        { extension: "pdf", value: "application/pdf" },
        { extension: "ppt", value: "application/vnd.ms-powerpoint" },
        { extension: "pptx", value: "application/vnd.ms-powerpoint" },
        { extension: "rar", value: "application/x-rar-compressed" },
        { extension: "xls", value: "application/msexcel" },
        { extension: "xlsx", value: "application/msexcel" },
        { extension: "zip", value: "application/zip" },
        { extension: "txt", value: "text/plain" }
    ];
    allowedExtensions = ['.pdf', '.csv', '.txt', '.xlsx', '.xls', '.docx', '.doc', '.png', '.jpg', '.jpeg', '.ppt', '.pptx', '.gif', '.zip']; // For the attachment files
    multiLineTooltip = `<ul class="p-mt-0 p-pl-4 p-mb-0">
    <li>Files with extensions: ${this.allowedExtensions.join(', ')} are allowed</li>
    <li>Maximum size should be less than or equal to 10MB</li>
  </ul>`;
    dialogHeader: 'Add New Notification Template' | 'Edit Notification Template' = 'Add New Notification Template';
    fieldTypes: any[] = [];
    fieldTypesByGroup: any[] = [];
    currentColList: any[] = [];
    selectedField: any = null;
    selectedInsertField: string = "";
    addedFieldTags: string[] = [];
    isActive: boolean = true;
    emailDetailsForm: FormGroup = new FormGroup({});
    isUnsavedData: boolean = false;
    detailsFormErrors: any = {};
    formErrorHandler: FormErrorHandler = new FormErrorHandler();
    notificationTypeEnum = EmailTemplateNotificationTypesEnum;
    emailTemplateNotificationTypes = EmailTemplateNotificationTypes;
    emailTemplateActionTypes = EmailTemplateActionTypes;
    notificationBody: string = "";
    attachments: NotificationTemplateAttachments[] = [];
    displayFilePreview: boolean = false;
    currentFile: any = null;

    bodyCursorPosition = {
        start: 0,
        end: 0
    };

    contentCursorPosition = {
        start: 0,
        end: 0
    };

    hiddenFields: string[] = ['phone', 'contactEmail', 'social'];
    hiddenFieldsForProduct: string[] = ['packageBarcode','serialNoBarcode','lotNumber','revisionNumber','expirationDate'];

    visibleEmailGenerationScenario: boolean = false;
    availableFieldsLabel = {
        [ProductModuleId]: "Product",
        [EstimateOrderModuleId]: "Estimate",
        [SOModuleId]: "Sales Order",
        [InvoiceOrderModuleId]: "Invoice"
    };

    editorModules = {};
    defaultAIImage = `${environment.assestsBasePath}layout/images/ai-icon.png`;


    constructor(
        private fb: FormBuilder,
        public app: AppMainComponent,
        private messageService: MessageService,
        private appMainService: AppMainService,
        private emailTemplateService: EmailTemplateService,
        private documentsService: MyDocumentsService,
        private documentViewerService: DocumentViewerService,
        private sharedTemplateService: SharedTemplateService,
        private configService: ConfigurationService,
        private purchaseService: PurchasesService,
        private renderer: Renderer2
    ) { }

    ngOnInit(): void {
        this.initEditorModules();
        this.templateEmailForm();
    }

    ngOnChanges(changes: SimpleChanges): void {

        if (changes?.moduleId?.currentValue) {
            this.moduleId = changes.moduleId.currentValue;
        }

        if (changes['channelNames'] && changes['channelNames']?.currentValue) {
            this.channelNames = changes['channelNames']?.currentValue;

            if (this.channelNames?.length > 0) {
                const selectedChannel = this.channelNames.find(channel => channel.isDefault) || null;
                this.emailDetailsForm.patchValue({
                    selectedChannel: selectedChannel
                });

                this.getTemplateFields();
            }
        }

        if (changes?.selectedEmailTemplate?.currentValue) {
            this.selectedEmailTemplate = changes.selectedEmailTemplate.currentValue;

            if (this.selectedEmailTemplate) {
                this.getEmailTemplateDetails(this.selectedEmailTemplate);
                // this.setTemplateEditDetails(this.selectedEmailTemplate);
            }
        }
    }

    templateEmailForm() {
        this.formErrorHandler = new FormErrorHandler();
        this.dialogHeader = 'Add New Notification Template';
        this.detailsFormErrors = {};
        this.isActive = true;
        this.attachments = [];
        this.emailDetailsForm = this.fb.group({
            id: [0],
            organizationId: [this.app.user.organizationId],
            selectedChannel: ['', Validators.required],
            notificationType: [this.emailTemplateNotificationTypes[0]],
            actionType: [this.emailTemplateActionTypes[0]],
            templateName: ['', Validators.required],
            templateSubject: ['', Validators.required],
            templateBody: ['', Validators.required],
            messageContent: [''],
            isHtmlBody: [true],
            isDefault: [false],
            isEnclosureRequired: [false],
            isEditable: [true]
        });
        this.notificationBody = "";

        this.formErrorHandler.handleErrors(this.emailDetailsForm, this.detailsFormErrors, {
            templateName: {
                required: "Enter Template Name",
            },
            templateSubject: {
                required: "Enter notification template subject",
                invalidFieldTags: "Template subject have invalid field tags:"
            },
            templateBody: {
                required: "Enter notification template body",
                invalidFieldTags: "Template body have invalid field tags:"
            },
            selectedChannel: {
                required: "Select any channel",
            }
        });

        this.emailDetailsForm.get('templateBody').valueChanges.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(value => {
            this.notificationBody = value;
            this.updatedAddedTags();
        })

        this.emailDetailsForm.get('templateSubject').valueChanges.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(value => {
            this.updatedAddedTags();
        })

        if (this.channelNames?.length > 0) {
            const selectedChannel = this.channelNames.find(channel => channel.isDefault) || null;
            this.emailDetailsForm.patchValue({
                selectedChannel: selectedChannel
            });

            this.getTemplateFields();
        }
    }

    uploadAttachments(files: File[]) {
        this.appMainService.isShowSpinner('upload');
        if (typeof Worker !== undefined) {
            const maxTotalSizeInMB = 10;
            const maxTotalSizeInBytes = maxTotalSizeInMB * 1024 * 1024;
            // Step 1: Calculate existing uploaded attachments size
            let existingSize = this.attachments?.reduce((sum, ea) => sum + (ea.attachment?.sizeInBytes || 0), 0);
      
      
            // Step 2: Calculate newly selected files size
            let newFilesSize = 0;
            for (let file of files) {
              newFilesSize += file.size;
            }
      
      
            if ((existingSize + newFilesSize) > maxTotalSizeInBytes) {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: `Total attachments size cannot exceed ${maxTotalSizeInMB} MB.`
              });
              this.appMainService.isHideSpinner('upload');
              return;
            }
            for (let file of files) {
                const isFileAlreadyUploaded = this.attachments.some(el => el.fileName === file.name);
                if (isFileAlreadyUploaded) {
                  // File is already selected
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: `${file.name} is already selected. Please choose a different file.`
                  });
                } else {
                    let errors = validateFiles(file, maxTotalSizeInMB, this.allowedExtensions);
                if (errors.length > 0) {
                    for (let error of errors) {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: error.fileName + ": " + error.error });
                    }
                    this.appMainService.isHideSpinner('upload');
                } else {
                    uploadFiles(file, ({ name, content, size, extension }) => {

                        let mime_type = this.mimeTypes.find(el => el.extension === extension.toLowerCase());

                        let attachment = {
                            id: 0,
                            createdSource: this.app.userIP,
                            updatedSource: this.app.userIP,
                            createdBy: this.app.user.userId,
                            updatedBy: 0,
                            createdDate: new Date(),
                            updatedDate: new Date(),
                            name: name,
                            guidName: "",
                            content: content,
                            extension: extension,
                            sizeInBytes: size,
                            mediaType: mime_type?.value || "",
                            description: "",
                            statusId: Status.Active,
                            isValid: true,
                            moduleName: this.moduleId == AccountModuleId ? 'Account' : 'Lead',
                            isModuleFolder: true
                        };

                        this.attachments.push({
                            notificationTemplateId: this.emailDetailsForm.value.id,
                            id: 0,
                            fileName: name,
                            displayFileName: name,
                            filePath: name,
                            mediaType: mime_type?.value || "",
                            fileSize: size,
                            statusId: Status.Active,
                            attachment: attachment
                        });
                        this.appMainService.isHideSpinner('upload');
                    });
                }
                }
            }
        } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: "Please update the browser. Web Workers are not supported in the older versions of this browser." });
        }
        this.appMainService.isHideSpinner('upload');
    }

    removeAttachment(attachment: any, index: number) {
        if (attachment?.id > 0) {
            attachment.statusId = Status.Deleted;
        } else {
            this.attachments.splice(index, 1);
        }
    }

    saveNotificationTemplate() {
        this.updatedAddedTags();
        if (this.emailDetailsForm.invalid) {
            this.formErrorHandler.showErrorOnSubmit();
            this.scrollToError();
            return; //Return if form invalid
        }

        const templateData: NotificaitonEmailTemplateConfigModel = {
            id: this.emailDetailsForm.value.id,
            organizationId: this.emailDetailsForm.value.organizationId,
            objectId: this.moduleId,
            channelId: this.emailDetailsForm.value.selectedChannel?.id,
            channelName: this.emailDetailsForm.value.selectedChannel?.name,
            templateName: this.emailDetailsForm.value.templateName,
            templateSubject: this.emailDetailsForm.value.templateSubject,
            templateBody: this.emailDetailsForm.value.notificationType?.id === this.notificationTypeEnum.Email ? this.notificationBody : "",
            messageContent: this.emailDetailsForm.value.notificationType?.id !== this.notificationTypeEnum.Email ? this.notificationBody : "",
            notificationType: this.emailDetailsForm.value.notificationType.id,
            actionType: this.emailDetailsForm.value.actionType.id,
            isHtmlBody: this.emailDetailsForm.value.isHtmlBody,
            isDefault: this.emailDetailsForm.value.isDefault,
            isEditable: this.emailDetailsForm.value.isEditable,
            isEnclosureRequired: this.emailDetailsForm.value.isEnclosureRequired,
            statusId: this.isActive ? Status.Active : Status.InActive,
            notificationTemplateFields: [],
            notificationTemplateAttachments: []
        }

        templateData.templateBody = addInlineStyles(templateData.templateBody);

        this.attachments.map(attachment => {
            templateData.notificationTemplateAttachments.push({
                ...attachment,
                attachment: attachment.id > 0 ? null : attachment.attachment
            })
        })

        this.addedFieldTags.map(labelName => {
            const exist = this.fieldTypes.find(field => field.name.trim() == labelName.trim());
            if (exist) {
                let id = 0;

                if (this.selectedEmailTemplate) {
                    const addedField = this.selectedEmailTemplate.notificationTemplateFields.find(field => field.placeHolderFieldName == exist.field);
                    id = addedField ? addedField.id : 0;
                }

                templateData.notificationTemplateFields.push({
                    id: id,
                    notificationTemplateId: this.selectedEmailTemplate?.id || 0,
                    placeHolderFieldName: exist.field || exist.name.trim(),
                    placeHolderName: exist.name.trim(),
                    columnSettingId: exist.id,
                    statusId: 1,
                    isCustom: exist.custom
                })
            }
        });

        //Set removed fields
        if (this.selectedEmailTemplate) {
            this.selectedEmailTemplate.notificationTemplateFields.map(previousField => {
                const exist = templateData.notificationTemplateFields.find(field => field.placeHolderFieldName == previousField.placeHolderFieldName);
                if (!exist) {
                    templateData.notificationTemplateFields.push({
                        ...previousField,
                        statusId: 3
                    })
                }
            })
        }

        if (templateData.id > 0) {
            this.appMainService.isShowSpinner('saveEmailTemplate');
            this.emailTemplateService.updateEmailTemplate(templateData).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                next: (response) => {
                    this.appMainService.isHideSpinner('saveEmailTemplate');
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Email Template Updated!' });
                    this.refreshList.emit(true);
                    this.onDialogClose();
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('saveEmailTemplate');
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update Email Template Information!' });
                }
            })
        } else {
            this.appMainService.isShowSpinner('saveEmailTemplate');
            this.emailTemplateService.addEmailTemplate(templateData).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                next: (response) => {
                    this.appMainService.isHideSpinner('saveEmailTemplate');
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Email Template Added!' });
                    this.refreshList.emit(true);
                    this.onDialogClose();
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('saveEmailTemplate');
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to add Email Template Information!' });
                }
            })
        }
    }

    getEmailTemplateDetails(templateDetails: NotificaitonEmailTemplateConfigModel) {
        this.appMainService.isShowSpinner('getEmailTemplate');
        this.emailTemplateService.getEmailTemplateById(templateDetails.id, templateDetails.statusId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response) => {
                this.appMainService.isHideSpinner('getEmailTemplate');
                if (response) {
                    this.setTemplateEditDetails(response);
                }
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getEmailTemplate');
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load Email Template Information!' });
            }
        })
    }

    setTemplateEditDetails(templateDetails: NotificaitonEmailTemplateConfigModel) {
        this.dialogHeader = 'Edit Notification Template';

        const selectedChannel = this.channelNames.find(channel => channel.id == templateDetails.channelId) || null;
        const selectedNotificationType = this.emailTemplateNotificationTypes.find(type => type.id === templateDetails.notificationType) || this.emailTemplateNotificationTypes[0];
        const selectedActionType = this.emailTemplateActionTypes.find(type => type.id === templateDetails.actionType) || this.emailTemplateActionTypes[0];

        this.isActive = templateDetails.statusId == 1 ? true : false;

        this.emailDetailsForm.patchValue({
            id: templateDetails.id,
            organizationId: templateDetails.organizationId,
            selectedChannel: selectedChannel,
            templateName: templateDetails.templateName,
            templateSubject: templateDetails.templateSubject,
            templateBody: templateDetails.notificationType === this.notificationTypeEnum.Email ? templateDetails.templateBody : templateDetails.messageContent,
            notificationType: selectedNotificationType,
            actionType: selectedActionType,
            isHtmlBody: templateDetails.isHtmlBody,
            isDefault: templateDetails.isDefault,
            isEditable: templateDetails.isEditable,
            isEnclosureRequired: templateDetails.isEnclosureRequired
        });

        this.attachments = templateDetails.notificationTemplateAttachments?.length > 0 ? templateDetails.notificationTemplateAttachments.filter(attachment => attachment.statusId == Status.Active) : [];

        this.notificationBody = templateDetails.notificationType === this.notificationTypeEnum.Email ? templateDetails.templateBody : templateDetails.messageContent;

        if(this.editor && this.notificationBody){
            this.loadContentInEditor(this.notificationBody);
        }

        const subCtrl = this.emailDetailsForm.get('templateSubject');
        const nameCtrl = this.emailDetailsForm.get('templateName');

        if (this.isView) {
            subCtrl.disable();
            nameCtrl.disable();
        } else {
            subCtrl.enable();
            nameCtrl.enable();
        }

        this.getTemplateFields();
    }

    selectTemplateField($event) {
        const selectedField: any = $event.value;

        if (selectedField?.childGroup || !selectedField) return;

        if (this.selectedInsertField == 'templateSubject') {
            // const cursorPosition = this.getSubjectCursorPosition();
            const subjectText = this.emailDetailsForm.value.templateSubject;
            const insertedText = `${subjectText} [${selectedField.name.trim()}]`;
            this.emailDetailsForm.patchValue({
                templateSubject: insertedText
            })
        } else {
            if (this.editor && this.emailDetailsForm.value.isHtmlBody) {
                const _quill = this.editor.getQuill();

                const selection = _quill.getSelection(true);
                const fieldText: string = ` [${selectedField.name.trim()}] `;
                _quill.insertText(selection?.index || 0, fieldText);
                this.emailDetailsForm.patchValue({
                    templateBody: _quill.root.innerHTML
                })
                this.notificationBody = _quill.root.innerHTML;
                this.loadContentInEditor(this.notificationBody);
                const nextCursorPoint = (selection?.index || 0) + (fieldText.length - 1);

                setTimeout(() => {
                    _quill.setSelection(nextCursorPoint, 0);
                }, 200)
            }

            if (!this.emailDetailsForm.value.isHtmlBody) {
                let bodyText = this.emailDetailsForm.value.templateBody;
                const firstHalf = `${bodyText.substring(0, this.bodyCursorPosition.start)} [${selectedField.name}] `;
                bodyText = `${firstHalf}${bodyText.substring(this.bodyCursorPosition.end, bodyText.length)}`;
                this.emailDetailsForm.patchValue({
                    templateBody: bodyText
                });
                const nextCursorPoint = firstHalf.length - 1;
                this.templateBodyAreaEl.nativeElement.focus();
                this.templateBodyAreaEl.nativeElement.setSelectionRange(nextCursorPoint, nextCursorPoint);
            }
        }

        setTimeout(() => {
            this.selectedField = null;
            this.updatedAddedTags();
        }, 200)
    }

    updatedAddedTags() {
        this.addedFieldTags = [];
        const value = this.emailDetailsForm.value.templateBody + this.emailDetailsForm.value.templateSubject;
        if (value) {
            const addedTags: string[] = value.match(customFieldTagRegex) || [];

            addedTags.map(labelName => {
                const exist = this.fieldTypes.find(field => field.name.trim() == labelName.trim());

                if (exist) {
                    if (!this.addedFieldTags.includes(exist.name))
                        this.addedFieldTags.push(exist.name);
                }
            })
        }
    }

    selectChannel($event: any) {
        this.getTemplateFields();

    }

    // getTemplateList() {
    //     this.configService.getTemplateDetails(this.moduleId, this.moduleId, this.emailDetailsForm.value.selectedChannel?.id, true).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((res) => {
    //         this.fieldTypes = res?.length>0? res.filter(x=> x.field && !this.removedFields.includes(x.field)) : [];
    //         this.updatSubjectValidators();
    //         this.updateBodyValidators();
    //     })
    // }

    getTemplateFields() {
        // this.getSavedSearchTemplateFields();
        const moduleIds: number[] = [ProductModuleId,EstimateOrderModuleId,SOModuleId,InvoiceOrderModuleId];
        if(moduleIds.includes(this.moduleId)) {
            this.appMainService.isShowSpinner('getColumnSettings');
            this.configService.getTemplateDetails(this.moduleId, this.moduleId ,this.emailDetailsForm.value.selectedChannel?.id, true).subscribe({
                next: (response) => {
                   this.fieldTypes = response;
                    this.generateAvailableFieldsForProduct();
                    this.appMainService.isHideSpinner('getColumnSettings');
                },
                error: (error) =>
                {
                    this.appMainService.isHideSpinner('getColumnSettings');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.Message : 'Column Settings are not loaded, please try again...'
                    });
                },
            })
        } else if([VendorModuleId].includes(this.moduleId)) {
            this.loadVendorConfiguration();
        } else if([LocationModuleId , TaskModuleId].includes(this.moduleId)) {
            this.getSavedSearchTemplateFields();
        } 
     else if([PurchaseOrderModuleId,BillOrderModuleId,VendorReturnModuleId,VendorCreditModuleId,BillPaymentModuleId].includes(this.moduleId)){
                this.getAssociatedTemplateFields(VendorModuleId,333);
            }
        else {
            this.appMainService.isShowSpinner('getColumnSettings');
            this.sharedTemplateService.getTemplateSectionsForFormBuild(this.moduleId, this.emailDetailsForm.value?.selectedChannel?.id).subscribe(
                {
                    next: (response) =>
                    {
                        this.currentColList = response || [];
                        this.currentColList.map((fields, i) => [
                            fields.customFields.map((customFields, i) => {
                                const formControlDetails: any = ParseHelper.DeepCopy(customFields.formControl);
                                customFields = {
                                    ...customFields,
                                    formControl: formControlDetails?.type,
                                    formControlDetails: formControlDetails,
                                    isCustom: true
                                }

                                fields.customFields[i] = customFields;
                            })
                        ]);
                        this.generateAvailableFields();
                        this.appMainService.isHideSpinner('getColumnSettings');
                    },
                    error: (error) => {
                        this.appMainService.isHideSpinner('getColumnSettings');
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error?.error?.message ? error?.error?.Message : 'Column Settings are not loaded, please try again...'
                        });
                    },
                    complete: () => {

                },
            });
        }
    }

    getSavedSearchTemplateFields(){
        this.appMainService.isShowSpinner('getSavedSearchColumnSettings');
        this.sharedTemplateService.getTemplatesSectionsFieldsForSavedSearch(this.moduleId, this.moduleId, this.emailDetailsForm.value?.selectedChannel?.id).subscribe(
        {
            next: (response) => {
                this.currentColList = response || [];
                if(this.moduleId === TaskModuleId){
                    this.currentColList = this.currentColList.map(item => ({
                        ...item,
                        fields: item?.fields?.filter(field => field.enableSavedSearchColumnSetting)
                      }));                    
                }
                this.generateAvailableFields();
                this.appMainService.isHideSpinner('getSavedSearchColumnSettings');
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getSavedSearchColumnSettings');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.message ? error?.error?.Message : 'Column Settings are not loaded, please try again...'
                });
            },
            complete: () => {

            },
        });
    }

    loadVendorConfiguration(){
        this.appMainService.isShowSpinner('vendorFields');
        this.purchaseService.getPOConfigurations('Purchase').subscribe(config => {
            this.appMainService.isHideSpinner('vendorFields');
            //Product Templates
            const vendorTemplates = config.filter(config => (config.name == 'Purchase Template'))[0];
            const templates = JSON.parse(vendorTemplates.configurationDetails[0].configJSONValue);
            const vendorTemplate = templates.find((t) => t.templateName == 'Vendors_template');
            this.generateVendorAvailableFields(vendorTemplate);
        }, (error)=>{
            this.appMainService.isHideSpinner('vendorFields');
        });
    }

    generateVendorAvailableFields(vendorTemplate: any){
        let updateFields: any[] = WF_VENDOR_UPDATE_FIELDS;
        this.currentColList = [];
        updateFields.map((section, sectionInex)=>{
            const sectionData = {
                name: section.label,
                fields: [],
                customFields: []
            }

            if(vendorTemplate[section.sectionCode]?.length>0){
                vendorTemplate[section.sectionCode].map(checkfield=>{
                    if(checkfield?.isChecked){
                        sectionData.fields.push({
                            ...checkfield,
                            field: checkfield.code,
                            isCustom: checkfield.custom,
                            labelName: checkfield?.labelname||checkfield.name,
                            formControl: getFormControlNameById(checkfield?.formControlId)
                        })
                    }
                });

                this.currentColList.push(sectionData);
            }
        });

        this.generateAvailableFields();
    }

    generateAvailableFields(nameField: string = 'name') {
        this.fieldTypes = [];
        let fieldTypesByGroup = [];

        this.currentColList.map(sectionDetails => {
            const group = {
                label: sectionDetails.name,
                value: "",
                items: []
            }
            sectionDetails.fields.map(field => {
                if (field?.childFields?.length > 0) {
                    const childGroup = [];
                    field.childFields.map(childField => {
                        const fieldDetails = this.setFieldDetails(childField, nameField);
                        if (fieldDetails) childGroup.push({
                            ...fieldDetails,
                            label: fieldDetails.name,
                            childItem: true
                        })
                    })

                    if (childGroup.length > 0) {
                        childGroup.unshift({
                            name: field.name,
                            value: "",
                            childGroup: true
                        });

                        group.items = [...group.items, ...childGroup]
                    }
                } else {
                    const fieldDetails = this.setFieldDetails(field, nameField);
                    if (fieldDetails) group.items.push({
                        ...fieldDetails,
                        label: fieldDetails.name
                    })
                }
            });

            sectionDetails.customFields.map(field => {
                field = {...field, isCustom: true};
                const fieldDetails = this.setFieldDetails(field, nameField);
                if (fieldDetails) group.items.push({
                    ...fieldDetails,
                    label: fieldDetails.name
                })
            });

            fieldTypesByGroup.push(group);
        });
        this.fieldTypesByGroup = ParseHelper.DeepCopy(fieldTypesByGroup);
        this.updatSubjectValidators();
        this.updateBodyValidators();
    }

    generateAvailableFieldsForProduct(){
        this.fieldTypes = this.fieldTypes.filter(avalableActiveField => !this.hiddenFieldsForProduct.includes(avalableActiveField.field))
          let fieldTypesByGroup = [];
            const group: any = {
                label: this.availableFieldsLabel[this.moduleId],
                value: "",
                items: []
            }
            this.fieldTypes.map(field=>{
                group.items.push({
                    ...field,
                    label: field.labelname
                })
            });
            fieldTypesByGroup.push(group);
            this.fieldTypesByGroup = ParseHelper.DeepCopy(fieldTypesByGroup);
            this.updatSubjectValidators();
            this.updateBodyValidators();

    }

    setFieldDetails(fieldDetails: LeadAccountUpdateFieldsModel, nameField: string = 'name') {
        let field = null;
        if (fieldDetails?.field && fieldDetails?.mapObject!='opportunityProduct' && !this.hiddenFields.includes(fieldDetails.field) && ![FormControlList.FileUpload, FormControlList.Picture].includes(fieldDetails.formControl)) {
            field = {
                id: fieldDetails.id,
                labelname: fieldDetails.labelName,
                name: this.getFormatedName(fieldDetails, nameField),
                code: fieldDetails.field,
                isrequired: true,
                ischecked: true,
                isShowInSetting: true,
                isDuplicate: true,
                isGlobalSearch: true,
                width: "",
                movable: false,
                showForDrag: false,
                templateId: this.emailDetailsForm.value?.selectedChannel?.id || 0,
                sectionId: 0,
                custom: !!fieldDetails?.isCustom,
                formControlId: FormControlListIds[fieldDetails.formControl],
                formControl: fieldDetails.formControl,
                pickListValues: fieldDetails?.formControlDetails?.pickListValues || [],
                field: fieldDetails.field,
                mapObject: "",
                isColumnSetting: true,
                value: "",
                displayOrder: 0,
                fieldTypes: null,
                fieldDataType: "String",
                valueDataType: "String",
                operators: [],
                operatorsDD: []
            };

            this.fieldTypes.push(field);
        }

        return field;
    }

    getFormatedName(fieldDetails: LeadAccountUpdateFieldsModel, nameField: string = 'name') {
        let name = fieldDetails[nameField];

        if (fieldDetails.mapObject == 'leadSocial') {
            name = `Lead ${fieldDetails.name}`
        }

        if (fieldDetails.mapObject == 'accountSocial') {
            name = `Account ${fieldDetails.name}`
        }

        if (fieldDetails.mapObject == 'lead' && fieldDetails.field == 'businessName') {
            name = fieldDetails.labelName
        }

        return name;
    }

    updateBodyValidators() {
        const bodyCtrl = this.emailDetailsForm.get('templateBody');

        if (bodyCtrl) {
            bodyCtrl.setValidators([Validators.required, fieldTagsValidator(this.fieldTypes)]);
            bodyCtrl.updateValueAndValidity();
        }
    }

    updatSubjectValidators(addValidator: boolean = true) {
        const subjectCtrl = this.emailDetailsForm.get('templateSubject');

        if (subjectCtrl) {
            if (addValidator)
                subjectCtrl.setValidators([Validators.required, fieldTagsValidator(this.fieldTypes)]);
            else
                subjectCtrl.setValidators([]);

            subjectCtrl.updateValueAndValidity();
        }
    }

    changeNotificationType() {
        if (this.emailDetailsForm.value.notificationType?.id === this.notificationTypeEnum.Email) {
            this.updatSubjectValidators();
            this.emailDetailsForm.patchValue({
                isHtmlBody: true
            });
        } else {
            this.selectedInsertField = 'templateBody';
            this.updatSubjectValidators(false);
            this.emailDetailsForm.patchValue({
                isHtmlBody: false
            });
        }
    }

    // Scroll to error handler function
    scrollToError(): void {
        const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
        this.scrollTo(firstElementWithError);

        if (!firstElementWithError) {
            const secondElementWithError = document.querySelector('.p-invalid');
            this.scrollTo(secondElementWithError);
        }
    }

    // Scroll to error element
    scrollTo(el: Element): void {
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    setBodyCursorPosition(oField: any) {
        this.selectedInsertField = 'templateBody';
        if (oField?.selectionStart || oField?.selectionStart == '0') {
            this.bodyCursorPosition.start = oField.selectionStart || 0;
            this.bodyCursorPosition.end = oField.selectionEnd || 0;
        }
    }

    onEditorTextChange($event: any) {
        this.emailDetailsForm.patchValue({
            templateBody: $event.htmlValue
        })
    }

    setContentCursorPosition(oField: any) {
        if (oField?.selectionStart || oField?.selectionStart == '0') {
            this.contentCursorPosition.start = oField.selectionStart || 0;
            this.contentCursorPosition.end = oField.selectionEnd || 0;
        }
    }

    onDialogClose() {
        this.templateEmailForm();
        this.dialogClose.emit();
    }

    openFilePreview(file: any): void {
        this.displayFilePreview = true;
        this.currentFile = {
            ...file.attachment,
            downloadLink: file.attachment?.content ? file.attachment.content : file?.filePath
        };
    }

    closeFilePreview() {
        this.displayFilePreview = false;
    }

    downloadFile(name: string, content: string, attachmentId: number) {
        let ext = name.substring(name.lastIndexOf('.') + 1);
        ext = ext?.toLowerCase();
        let mime_type = this.mimeTypes.filter(el => el.extension === ext);
        if (mime_type.length > 0 && content) {
            const base64 = content;
            const mime = mime_type[0].value;
            const blob = this.dataURItoBlob(base64, mime);
            const file = new File([blob], name, { type: mime });
            saveAs(file, name)
        } else if (attachmentId > 0) {
            this.appMainService.isShowSpinner('downloadLink');
            this.documentsService.downloadPublicFile(attachmentId, true).subscribe({
                next: (data) => {
                    this.downloadedFile(data?.downloadLink);
                    this.appMainService.isHideSpinner('downloadLink');
                },
                error: (error: HttpErrorResponse) => {
                    this.appMainService.isHideSpinner('downloadLink');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: "Error occurred while download this file...",
                    });
                }
            })
        } else {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: "No content found to download...",
            });
        }
    }

    dataURItoBlob(dataURI: string, mimeType: string) {
        const kept = dataURI.split(",", 2);
        const byteString = atob(kept[1]);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([int8Array], { type: mimeType });
        return blob;
    }

    downloadedFile(url: string) {
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        a.download = 'todo-1.json';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    }

    openFileNewTab(attachmentDetails: any) {
        if (attachmentDetails?.id > 0) {

            this.appMainService.isShowSpinner('openFilePreview');
            let docType = attachmentDetails.name.substring(attachmentDetails.name.lastIndexOf('.') + 1);
            docType = docType?.toLowerCase();

            this.documentsService.downloadPublicFile(attachmentDetails.id, false).subscribe({
                next: (data) => {
                    // console.log(data);
                    switch (docType) {
                        case 'docx':
                            this.documentViewerService.selectDocumentType(docType, data?.encodedDownloadLink);
                            break;
                        case 'xlsx':
                            this.documentViewerService.selectDocumentType(docType, data?.encodedDownloadLink);
                            break;
                        case 'pptx':
                            this.documentViewerService.selectDocumentType(docType, data?.encodedDownloadLink);
                            break;
                        case 'csv':
                            this.documentViewerService.selectDocumentType(docType, data?.encodedDownloadLink);
                            break;
                        case 'pdf':
                            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
                            break;
                        case 'jpg':
                            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
                            break;
                        case 'png':
                            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
                            break;
                        case 'gif':
                            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
                            break;
                        case 'txt':
                            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
                            break;
                        default:
                            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
                    }
                    this.appMainService.isHideSpinner('openFilePreview');
                },
                error: (error: HttpErrorResponse) => {
                    this.appMainService.isHideSpinner('openFilePreview');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: "Error occurred while open this file...",
                    });
                }
            })
        }
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    showGenerateEmailDialog(): void {
        this.visibleEmailGenerationScenario = true;
    }

    setGeneratedEmail(generatedData: {subject: string, body: string}){
        this.emailDetailsForm.patchValue({
            templateSubject: generatedData.subject,
            templateBody: generatedData.body ?? '',
        });
        this.loadContentInEditor(generatedData.body,true);
    }

    closeGenerateDialog(){
        this.visibleEmailGenerationScenario = false;
    }

    //#region Quill Table
    initEditorModules(){
        const backgroundColors: string[] = EDITOR_COLORS;
        const globalThis = this;
        this.editorModules = {
            table: false,
            'better-table-plus': {
                operationMenu: {
                    items: {
                        unmergeCells: {
                            text: 'Unmerge cells'
                        },
                        // markDynamicRow: {
                        //     text: 'Mark/Unmark Dynamic Row',
                        //     iconSrc: TABLE_ROW_DOWN_ICON,
                        //     handler() {
                        //         if(this.tableSelection?.selectedTds?.length>0){
                        //             const rowNode = this.tableSelection?.selectedTds[0]?.parent?.domNode;
                        //             if(rowNode){
                        //                 const currentId = rowNode.getAttribute('id');

                        //                 if (currentId === 'email-template-table-dynamic-row') {
                        //                     globalThis.renderer.removeAttribute(rowNode, 'id');
                        //                 } else {
                        //                     globalThis.renderer.setAttribute(rowNode, 'id', 'email-template-table-dynamic-row');
                        //                 }

                        //                 this.quill.update(Quill.sources.USER);
                        //                 this.tableSelection.clearSelection();
                        //                 globalThis.loadContentInEditor(this.quill.root.innerHTML,true);
                        //             }
                        //         }
                        //     }
                        // }
                    },
                    color: {
                        colors: backgroundColors,
                        text: 'Background'
                    }
                }
            }
        }
    }

    insertTable(){
        let quill = this.editor.getQuill();
        quill.focus();
        const tableModule = quill.getModule('better-table-plus');
        tableModule.insertTable(2, 5)
    }

    loadContentInEditor(text: any, updateSelf: boolean = false){
        if(updateSelf){
            this.notificationBody = text;
        }
        setTimeout(()=>{
            const _quill = this.editor.getQuill();
            const editorContainer = _quill.root;
            this.renderer.setProperty(editorContainer, 'innerHTML', text);
        })
    }
    //#endregion Quill Table End
    
    getAssociatedTemplateFields(parentObjectId: number, assosModuleId: number){
        this.appMainService.isShowSpinner('getColumnSettings');
        this.sharedTemplateService.getTemplatesSectionsFieldsForSavedSearch(parentObjectId, assosModuleId,this.emailDetailsForm.value?.selectedChannel?.id).subscribe(
        {
            next: (response) => {
                this.currentColList = response || [];
                this.currentColList
                .map((section, i)=>{
                    section.customFields.map((customFields, i)=>{
                        const formControlDetails: any = ParseHelper.DeepCopy(customFields.formControl);
                        customFields = {
                            ...customFields,
                            formControl: formControlDetails?.type,
                            formControlDetails: formControlDetails,
                            isCustom: true
                        }

                        section.customFields[i] = customFields;
                    })
                    section.customFields = section.customFields.filter((fields) => fields?.enableSavedSearchColumnSetting);
                    section.fields = section.fields.filter((fields) => fields?.enableSavedSearchColumnSetting);
                    section.fields.map((fields, i)=>{
                        if(fields.childFields?.length>0){
                        fields.childFields = fields.childFields.filter((childField) => childField.enableSavedSearchColumnSetting);
                        }
                    })                   
                });
                this.generateAvailableFields('labelName');
                this.appMainService.isHideSpinner('getColumnSettings');
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getColumnSettings');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.message ? error?.error?.Message : 'Column Settings are not loaded, please try again...'
                });
            },
            complete: () => {

            },
        });
    }
    
    
}
